import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import useDeepCompareEffect from "use-deep-compare-effect"
import * as Components from "../../components/components"
import { getSteuerBerechnungsOptions } from "../../constants"
import { EventBus } from "../../eventbus"
import { FeatureService } from "../../services/FeatureService"
import { getSteuerberechnungsOption } from "../../Utils"
import SteuerDetail from "./Detail"
import { groupByUmsatzsteuer } from "./utils"
import { useStoreRechnung } from "../../store"

export default function SteuerDetailsView() {
    const { t } = useTranslation()
    const rechnung = useStoreRechnung("positionen", "rechnungZuschlaege", "rechnungAbschlaege", "steuerDetails", "steuerberechnung")

    const groupedSteuerdetails = groupByUmsatzsteuer({
        positionen: rechnung.positionen,
        rechnungAbschlaege: rechnung.rechnungAbschlaege,
        rechnungZuschlaege: rechnung.rechnungZuschlaege,
        steuerDetails: rechnung.steuerDetails,
        steuerberechnung: rechnung.steuerberechnung,
    })

    useDeepCompareEffect(() => {
        EventBus.instance.emit("changeProperty", `steuerDetails`, groupedSteuerdetails)
    }, [groupedSteuerdetails])

    const steuerBerechnungsOptions = getSteuerBerechnungsOptions()

    const onChangeSteuerberechnung = useCallback<() => (value: unknown) => void>(
        () => (value) => {
            EventBus.instance.emit("changeProperty", `steuerberechnung`, value)
        },
        [],
    )

    return (
        <Components.Collapsible title={t("rechnung.steuerDetails.title")} collapsed={true}>
            {!groupedSteuerdetails || (groupedSteuerdetails.length === 0 && <>{t("rechnung.steuerDetails.keineSteuerDetails")}</>)}

            {FeatureService.isFeatureActive("STEUERBERECHNUNG") && groupedSteuerdetails && (
                <>
                    <Components.FormGroup label={t("rechnung.steuerDetails.steuerberechnung.label")}>
                        <Components.MultiSelect
                            placeholder={t("rechnung.steuerDetails.steuerberechnung.placeholder")}
                            value={steuerBerechnungsOptions.find((o) => o.value === getSteuerberechnungsOption(rechnung.steuerberechnung))}
                            options={steuerBerechnungsOptions}
                            onChange={onChangeSteuerberechnung()}
                        />
                    </Components.FormGroup>
                    <hr />
                </>
            )}

            {groupedSteuerdetails.map((gp, idx) => (
                <React.Fragment key={idx}>
                    <SteuerDetail key={idx} index={idx} steuerDetails={gp} />
                    {idx !== groupedSteuerdetails.length - 1 && <hr />}
                </React.Fragment>
            ))}
        </Components.Collapsible>
    )
}
